<!-- 推荐 -->
<template>
  <div class="contentbox">
    <el-dialog :visible.sync="visible" width="40%" :close-on-click-modal="false" :append-to-body="true"
      @close="dialogClose">
            <div class="title">找回密码</div>
            <div class="mt-16">
              <el-steps :active="active" align-center>
                <el-step title="验证身份"></el-step>
                <el-step title="设置密码"></el-step>
                <el-step title="重置成功"></el-step>
              </el-steps>
            </div>
            <!-- 内容 -->
            <div style="margin-top: 82px;padding-bottom: 40px;">
              <!-- 选择相应身份 -->
              <SfForm v-if="active == 0" @activeNum="activeNum"></SfForm>
              <!-- 填写注册资料 -->
              <RegisterForm v-if="active == 1" @activeNum="activeNum"></RegisterForm>
              <!-- 注册成功 -->
              <SfSuccess v-if="active == 2" @activeNum="activeNum"></SfSuccess>
            </div>
    </el-dialog>
  </div>
</template>
<script>
  // import { register, sendTemplateMail } from "@/api/login";
  import SfForm from "./sfForm.vue";
  import RegisterForm from "./registerForm.vue"
  import SfSuccess from "./sfSuccess.vue"
  export default {
    props: {
      dialogFormVisibleThree: {
        type: Boolean,
        default: function() {
          return false
        }
      },
    },
    components: {
      SfForm,
      RegisterForm,
      SfSuccess
    },
    data() {
      return {
        active: 0,
        visible: false
      };
    },

    watch: {
      dialogFormVisibleThree() {
        this.visible = this.dialogFormVisibleThree;
      },
    },
    created() {},
    mounted() {
      // this.drawLine();
    },
    methods: {
      dialogClose() {
        this.$emit("update:dialogFormVisibleThree", false);
        this.visible = false
      },
      activeNum(val) {
        this.active = val
      },
    }
  };
</script>
<style>
</style>
<style scoped>
  .title {
    font-size: 36px;
    color: #000000;
    font-weight: 600;
    text-align: center;
    margin-bottom: 56px;
  }
  .contentbox {
    /* padding-bottom: 100px; */
  }

  .pd-lr-260 {
    padding: 0 15%;
  }

  .pt-110 {
    padding-top: 110px;
  }

  .pd-lrtb-230 {
    padding: 40px 80px 50px 20%;
  }

  .ft-co-ff1 {
    color: #FF1F1F;
  }

  .hd_wh_gq {
    width: 100%;
    height: 80px;
    line-height: 80px;
    background: #FFFFFF;
    box-shadow: 0px 2px 16px 1px rgba(184, 184, 184, 0.25);
    border-radius: 0px 0px 0px 0px;
    opacity: 1;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999
  }
  >>> .el-step__icon.is-text {
    border-radius: 50%;
    border: 2px solid;
    border-color: inherit;
    background-color: #0177FB;
    width: 40px;
    height: 40px;
  }
  >>> .el-step__title.is-process {
    font-weight: 400;
    color: #0177FB;
    background-color: #fff;
  }
  >>> .el-step__head.is-process {
    color: white;
    border-color: #0177FB;
    /* background-color: #fff; */
}
>>> .el-step__head.is-wait .el-step__icon.is-text {
  color: #BEBEBE;
  border-color: #BEBEBE;
  background-color: #FFFFFF;
}
>>> .el-step__head.is-finish {
  color: white;
  border-color: #0177FB;
}
>>>.el-step__line{
  margin-top: 7px;
}
</style>



// WEBPACK FOOTER //
// src/components/forgetPassword/index.vue